import Vue from 'vue'

// axios
import axios from 'axios'
import eventBus from '@/eventBus'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_CFC_PATH,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.response.use(response => response, error => {
  if (error.response?.status === 419) {
    eventBus.$emit('session-expired')
    return Promise.reject(error)
  }
  return Promise.reject(error)
})

Vue.prototype.$http = axiosIns

export default axiosIns
